import styled from 'styled-components';
import colors from '@theme/colors';

const AnalystSelectorComponent = {
  paper: {
    overflow: 'hidden',
    display: 'inline-block',
    width: '100%',
  },
  listStyle: {
    paddingBottom: 0,
    paddingTop: 0,
  },
  menuItem: {
    cursor: 'default',
  },
};

const Container = styled.div`
  display: flex;
`;
const Title = styled.div``;
const List = styled.ul``;

const MainContainer = styled.div``;

export default {
  AnalystSelectorComponent,
  Title,
};



// WEBPACK FOOTER //
// ./components/layout/ClientEditPage.js